import { useRef } from 'react'

export const useFilterRefs = () => {
  const buttonRefs = useRef<Record<string, HTMLButtonElement | null>>({})
  const panelRef = useRef<HTMLDivElement | null>(null)
  const previouslyFocusedButtonRef = useRef<HTMLButtonElement | null>(null)
  const filtersRef = useRef<HTMLDivElement | null>(null)

  return {
    previouslyFocusedButtonRef,
    panelRef,
    buttonRefs,
    filtersRef,
  }
}
